// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, HasPagingParameters, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { OrderComplaintModel } from "@insite/client-framework/Types/ApiModels";

export interface GetOrdersApiParameter extends ApiParameter, HasPagingParameters {
    orderNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    orderTotalOperator?: string;
    orderTotal?: number;
    productErpNumber?: string;
    sort?: string;
    displayName?: string;
    vmiOrdersOnly?: boolean;
    vmiLocationId?: string;
    vmiBinId?: string;
    expand?: ("orderLines" | "vmidetails")[];
    showMyOrders?: boolean;
    // Greif
    fromDeliveryDate?: string;
    toDeliveryDate?: string;
    webOrderNumber?: string;
}

export interface AddOrderComplaintApiParameter extends ApiParameter {
    orderComplaintModel: OrderComplaintModel;
}

export async function addOrderComplaint(
    parameter: AddOrderComplaintApiParameter,
): Promise<ServiceResult<OrderComplaintModel>> {
    try {
        const orderComplaintModel = await post<OrderComplaintModel>(
            `api/v1/custom/claimsanddisputes/sendnotification`,
            parameter.orderComplaintModel,
        );
        return {
            successful: true,
            result: orderComplaintModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
